var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.5C10.5 14 9.38074 15 8.00003 15C6.61932 15 5.50003 14 5.50003 12.5M12.5 6.66667V6C12.5 3.42974 10.395 1.5 8 1.5C5.605 1.5 3.5 3.42976 3.5 6V6.66667C3.5 8.86666 1.5 9.4 1.5 10.6667C1.5 11.8 3.93333 12.5 8 12.5C12.0667 12.5 14.5 11.8 14.5 10.6667C14.5 9.4 12.5 8.86666 12.5 6.66667Z",
    stroke: "#67726D",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.6031724915f88d539cbbb0671362ad5b.svg";
export { ForwardRef as ReactComponent };